export default "__VITE_ASSET__Bc_2A9zG__"